import React, { useLayoutEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
  UilEnvelope,
  UilChat,
  UilShoppingCart,
  Uil500px,
  UilBagAlt,
  UilCalendarAlt,
  UilUsersAlt,
  UilAt,
  UilClipboardAlt,
  // UilExpandArrowsAlt,
  UilCheckSquare,
  UilExchange,
  UilFile,
  UilHeadphones,
  UilChartBar,
  UilCompactDisc,
  UilTable,
  UilSquareFull,
  UilApps,
  UilEdit,
  UilMap,
} from '@iconscout/react-unicons';
import { TopMenuStyle } from './Style';

function TopMenu() {
  const path = '/admin';

  useLayoutEffect(() => {
    const active = document.querySelector('.hexadash-top-menu a.active');
    const activeDefault = () => {
      const megaMenu = active.closest('.megaMenu-wrapper');
      const hasSubMenuLeft = active.closest('.has-subMenu-left');
      if (!megaMenu) {
        active.closest('ul').previousSibling.classList.add('active');
        if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
      } else {
        active.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
      }
    };
    window.addEventListener('load', active && activeDefault);
    return () => window.removeEventListener('load', activeDefault);
  }, []);

  const addParentActive = (event) => {
    document.querySelectorAll('.parent').forEach((element) => {
      element.classList.remove('active');
    });

    const hasSubMenuLeft = event.currentTarget.closest('.has-subMenu-left');
    const megaMenu = event.currentTarget.closest('.megaMenu-wrapper');
    if (!megaMenu) {
      event.currentTarget.closest('ul').previousSibling.classList.add('active');
      if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
    } else {
      event.currentTarget.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
    }
  };
  return (
    <TopMenuStyle>
      <div className="hexadash-top-menu ltr:pl-[20px] rtl:pr-[20px] xl:ltr:pl-[10px] xl:rtl:pr-[10px]">
        <ul>
          <li className="has-subMenu">
            <Link to="#" className="parent">
              Dashboard
            </Link>
          </li>
          <li>
            <NavLink to={`${path}/role`}>
              Role
            </NavLink>
          </li>
          <li>
            <NavLink to={`${path}/user`}>
              User
            </NavLink>
          </li>
          <li>
            <NavLink to={`${path}/course`}>
              Course
            </NavLink>
          </li>
          <li>
            <NavLink to={`${path}/class`}>
              Class
            </NavLink>
          </li>
          <li>
            <NavLink to={`${path}/file`}>
              File
            </NavLink>
          </li>
          <li>
            <NavLink to={`${path}/refer`}>
              Refer
            </NavLink>
          </li>
          <li>
            <NavLink to={`${path}/transactionHistory`}>
              Transaction History
            </NavLink>
          </li>
          <li>
            <NavLink to={`${path}/referral`}>
              Referral
            </NavLink>
          </li>
          <li>
            <NavLink to={`${path}/test`}>
              Test
            </NavLink>
          </li>
          <li>
            <NavLink to={`${path}/test/details`}>
              Test Details
            </NavLink>
          </li>
        </ul>
      </div>
    </TopMenuStyle>
  );
}

export default TopMenu;
